import { useState } from 'react';
import { message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { apiBuyerLoginPassword, apiBuyerLoginCaptcha, apiBuyerCaptchaSend } from '@/service/api';
import { ChannelTypeEnum, BuyerOperationTypeEnum } from '@/service/api/types';
import jsCookie from 'js-cookie'
import { TOKEN_KEY, BUYER_INFO_KEY } from '@/constants';
import { useRootStore } from '@/contexts';
import { useTranslation } from 'react-i18next';


export default () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation()
  // 获取重定向前的路径，如果是从 ProtectedRoute 跳转过来的
  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/';
  const [loading, setLoading] = useState(false);
  const [codeLoading, setCodeLoading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const {  userStore } = useRootStore()

  /**
   * 发送验证码
   */
  const sendCaptcha = async (account: string) => {
   
    if (countdown > 0) {
      return false;
    }

    try {
      setCodeLoading(true);
      const res = await apiBuyerCaptchaSend({
        account,
        operationType: BuyerOperationTypeEnum.LOGIN,
      });

      if (res.code === 0) {
        message.success(t('8c1f1d75'));
        // 开始倒计时
        let timer = 60;
        setCountdown(timer);
        const interval = setInterval(() => {
          timer--;
          setCountdown(timer);
          if (timer <= 0) {
            clearInterval(interval);
          }
        }, 1000);
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      if(error?.msg) {
        message.error(error.msg)
      }
      return false;
    } finally {
      setCodeLoading(false);
    }
  };

  /**
   * 密码登录
   */
  const loginByPassword = async (data: {
    account: string;
    password: string;
  }) => {
  
    try {
      setLoading(true);
      const res = await apiBuyerLoginPassword({
        account: data.account,
        password: data.password,
      });

      if (res.code === 0) {
        // 保存登录信息（可以根据需要存储到 localStorage 或状态管理）
        if (res.data?.accessToken) {
          jsCookie.set(TOKEN_KEY, res.data.accessToken);
        }
        if (res.data?.buyerInfo) {
          userStore.signIn(res.data.buyerInfo)
          localStorage.setItem(BUYER_INFO_KEY, JSON.stringify(res.data.buyerInfo));
        }
        // 登录成功后跳转到原页面或首页
        navigate(from, { replace: true });
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      if(error?.msg) {
        message.error(error.msg)
      }
      return false;
    } finally {
      setLoading(false);
    }
  };

  /**
   * 验证码登录
   */
  const loginByCaptcha = async (data: {
    account: string;
    captcha: string;
  }) => {
    try {
      setLoading(true);
      const res = await apiBuyerLoginCaptcha({
        account: data.account,
        captcha: data.captcha,
        channel: ChannelTypeEnum.WEB,
        operationType: BuyerOperationTypeEnum.LOGIN,
      });

      if (res.code === 0) {
        // 保存登录信息（可以根据需要存储到 localStorage 或状态管理）
        if (res.data?.accessToken) {
          jsCookie.set(TOKEN_KEY, res.data.accessToken);
        }
        if (res.data?.buyerInfo) {
          userStore.signIn(res.data.buyerInfo)
          localStorage.setItem(BUYER_INFO_KEY, JSON.stringify(res.data.buyerInfo));
        }
        // 登录成功后跳转到原页面或首页
        navigate(from, { replace: true });
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      if(error?.msg) {
        message.error(error.msg)
      }
      return false;
    } finally {
      setLoading(false);
    }
  };




  return {
    loading,
    codeLoading,
    countdown,
    sendCaptcha,
    loginByPassword,
    loginByCaptcha,
  };
}